namespace advisorop.components.servicer {

    export class RmdTrackerServicerController {

        constructor() { }

    }

    class RmdTrackerServicer implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {};
            this.controller = ["servicerService", RmdTrackerServicerController];
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/rmd-tracker-servicer.html";
        }
    }
    angular.module(Constants.APP).component("rmdTrackerServicer", new RmdTrackerServicer());
}